import React from 'react';
import Icon from '@/componentsDS/Icon/Icon'
import { IconSize, IconStyle } from '@/componentsDS/Icon/Icon.type';
import classname from 'classnames';
import { uniqueId } from 'lodash';
import PropTypes from 'prop-types';

export const VerificationStatus = {
	SUCCESS: 'success',
	FAILURE: 'failure'
}

const VerificationDetails = ({
	status,
	network,
	issuer,
	messages = [],
	learnMore
}) => {

	const isSuccess = status === VerificationStatus.SUCCESS;

	if (isSuccess && messages.length === 0) {
		messages = [
			'Attached documents have not been tampered with from their original state.'
		];
	}

	if (!isSuccess) {
		messages = [
			'Verification failed. We could not verify the following attachments in this transaction. Please check with the issuing party.'
		];
	}

	const verificationClassname = classname({
		'verification-details': true,
		'verification-details--success': isSuccess,
		'verification-details--failure': !isSuccess
	});

	return (
		<div className={verificationClassname}>
			<div className="verification-details__header">
				<h4 className="verification-details__title">
					Verification Details
				</h4>
			</div>
			<div className="verification-details__content">
				<div className="verification-details__section verification-details__section--list">
					<div className="verification-details__section__top">
						<div className="verification-details__section__left">
							<div className="verification-details__section__title">
								Verification:
							</div>
						</div>
						<div className="verification-details__section__right">
							<div className="verification-details__sub-title__left__button">
								<div
									className='verification-details__button'
									onClick={learnMore}
									onKeyDown={learnMore}
									role="none"
								>
									Learn more
								</div>
							</div>
						</div>
					</div>
					<div className="verification-details__section__bottom">
						<ul className="verification-details__list">
							{messages.map((message) => {
								const id = uniqueId(
									'verification-details__item-'
								);
								return (
									<li
										key={id}
										className="verification-details__item"
									>
										{isSuccess ? (
											<div className='verification-details__item__success-icon'>
												<Icon
													size={IconSize.SMALL}
													style={IconStyle.SOLID}
													name="check-circle"
												/>
											</div>

										) : (
											<div className='verification-details__item__failure-icon'>
												<Icon
													size={IconSize.SMALL}
													style={IconStyle.SOLID}
													name="exclamation-circle"
												/>
											</div>
										)}
										<span className="verification-details__text">
											{message}
										</span>
									</li>
								);
							})}
						</ul>
					</div>
				</div>

				{isSuccess && issuer && (
					<>
						<div className="verification-details__section">
							<div className="verification-details__section__top">
								<div className="verification-details__section__left">
									<div className="verification-details__section__title">
										Verified on:
									</div>
								</div>
							</div>
							<div className="verification-details__section__bottom">
								<span className="verification-details__text">
									{network || 'SGTraDex and Trade Trust'}
								</span>
							</div>
						</div>

						<div className="verification-details__section">
							<div className="verification-details__section__top">
								<div className="verification-details__section__left">
									<div className="verification-details__section__title">
										Issuer:
									</div>
								</div>
							</div>
							<div className="verification-details__section__bottom">
								<span className="verification-details__text">
									{issuer}
								</span>
							</div>
						</div>
					</>
				)}
			</div>

			<div className="verification-details__background-icon">
				{isSuccess ? (
					<div className='verification-details__item__success-icon'>
						<Icon
							size={IconSize.XLARGE}
							style={IconStyle.OUTLINED}
							name="check-circle"
						/>
					</div>
				) : (
					<div className='verification-details__item__failure-icon'>
						<Icon
							size={IconSize.XLARGE}
							style={IconStyle.OUTLINED}
							name="exclamation-circle"
						/>
					</div>
				)}
			</div>
		</div>
	);
};
VerificationDetails.propTypes = {
    status: PropTypes.oneOf([VerificationStatus.SUCCESS, VerificationStatus.FAILURE])
        .isRequired,
    network: PropTypes.string,
    issuer: PropTypes.string,
    messages: PropTypes.arrayOf(PropTypes.string),
    learnMore: PropTypes.func.isRequired,
};

export default VerificationDetails;
